<div class="inactivity-alert">
  <div class="title">
    <h1 mat-dialog-title>{{ 'INACTIVITY-DIALOG.TITLE' | translate }}</h1>
  </div>

  <div class="message">
    <p>{{ 'INACTIVITY-DIALOG.MESSAGE' | translate }}</p>
    <div class="flex flex-row gap-2 items-center justify-center">
      <ng-container *ngIf="countdown?.minutes">
        <div class="flex flex-col justify-center items-center w-24">
          <p class="font-semibold text-migo-primary text-7xl">
            {{ minutes }}
          </p>
          <span class="text-sm"
            >{{ 'INACTIVITY-DIALOG.MINUTE' | translate
            }}{{ (countdown.minutes || 0) > 1 ? 's' : '' }}</span
          >
        </div>

        <span>y</span>
      </ng-container>

      <div class="flex flex-col justify-center items-center w-24">
        <p class="font-semibold text-migo-primary text-7xl">
          {{ seconds }}
        </p>
        <span class="text-sm">{{
          'INACTIVITY-DIALOG.SECONDS' | translate
        }}</span>
      </div>
    </div>
  </div>

  <div class="actions">
    <button
      type="submit"
      class="migo-btn migo-btn--danger"
      [mat-dialog-close]="false"
    >
      <span>{{ 'COMMON.CLOSE-TEXT' | translate }}</span>
    </button>
    <button
      type="submit"
      class="migo-btn migo-btn--primary"
      (click)="extendSession()"
    >
    <span>{{ 'COMMON.EXTEND-TEXT' | translate }}</span>

    </button>
  </div>
</div>
